import React from 'react';
import { connect } from 'react-redux';
import TopNav from '../../components/common/TopNav/TopNav';
import SideNav from '../../components/common/SideNav/SideNav';
import Footer from '../../components/common/Footer/Footer';
import './layout.less';
import FullPageLoader from '../loader/fullPage-loader';
import ToastMessage from '../../components/common/toastMsg';
import { getUserData, setNotificationData } from '../../store/user/actions';
import { getNotificationMaster } from '../../store/layout/actions';
import PropTypes from 'prop-types';
import { Paper } from '@material-ui/core';
import WorkSpace from '../workspace';
import { routes } from '../../constants/routes';
import ErrorPage from '../ErrorPage';
import AllocationNotification from '../../components/common/NotificatioinPannel/notification';
import IdleSessionTimer from '../../components/common/idleTimer';
import DownloadProgress from '../../components/common/download-progress-bar';
import { setDownloaderVisibility } from '../../store/progressBar/actions';
import { IsSectionVisible } from '../../utils/helper';
import { SECTIONS } from '../../constants/appConstants';
import Banner from '../../components/common/Banner';

class Layout extends React.PureComponent {
  // Constructor
  constructor(props) {
    super(props);
    this.state = {
      currentPage: '',
      userData: this.props.userData,
      reloadTopNav: false,
      layout: this.props.layout
    };
  }

  // Get Notification details before component is mount
  componentDidMount() {
    if (!('Notification' in window)) {
      // console.log('This browser does not support desktop notification');
    } else {
      Notification.requestPermission();
    }
    if (this.props.userData === null || this.props.userData === undefined) {
      this.props.getUserData();
    }
    if (this.props.layout?.notificationData === null || this.props.layout?.notificationData === undefined || this.props.layout?.notificationData.length === 0) {
      this.props.getNotificationData();
    }
  }

  // Static method to get Derived state from new Props
  static getDerivedStateFromProps(newprops, state) {
    if (
      JSON.stringify(newprops.userData) !==
      JSON.stringify(state.userData) ||
      JSON.stringify(newprops.layout) !==
      JSON.stringify(state.layout)
    ) {
      return {
        userData: newprops.userData,
        reloadTopNav: !state.reloadTopNav,
        layout: newprops.layout
      };
    }
    return null;
  }

  // Reload the page. Reload the notifications
  handelReload = () => {
    this.props.getNotificationData();
    this.setState({ reloadTopNav: !this.state.reloadTopNav });
  }

  // Render method to render components based on conditions
  render() {
    const { layout, requestCount, showDownlodProgress, setDownloaderVisibility, downloadingFiles, userData } = this.props;

    return (
      <>
        <ToastMessage />
        <IdleSessionTimer></IdleSessionTimer>
        <FullPageLoader requestCount={requestCount} />
        <DownloadProgress downloadingFiles={downloadingFiles} showDownlodProgress={showDownlodProgress} setDownloaderVisibility={setDownloaderVisibility} />
        {window.location.href.indexOf('fileViewer') <= 0 &&
          <div className="layout-header-container">
            <TopNav {...this.props} pendingNotification={this.state.layout?.notificationData || []} reload={this.state.reloadTopNav} handelReload={this.handelReload} />
          </div>
        }
        <div className="layout-body-wrapper" >
          {window.location.href.indexOf('fileViewer') <= 0 &&
            <div className="layout-sidebar">
              <SideNav handelReload={this.handelReload} reload={this.state.reloadTopNav} />
            </div>
          }
          {layout.isInErrorState === true
            ? (
              <ErrorPage details={layout.commonLabel} {...this.props} />
            )
            : null}
          {this.props.userData !== null && this.props.userData !== undefined
            ? (<>
              <AllocationNotification {...this.props} />

              {layout.isInErrorState === true
                ? (
                  <ErrorPage details={layout.commonLabel} />
                )
                : null}
              <div className={window.location.href.indexOf('fileViewer') <= 0 ? 'layout-selected-route-container' : ''}>
                {
                  window.location.href.indexOf('fileViewer') <= 0 &&
                  <Banner userData={userData} />
                }
                <Paper style={{ height: '100%' }}>
                  <WorkSpace defaultPage={((((this.props.userData || {}).groups || [])[0] || {}).accessGroupConfigurationId || 0) === 10
                    ? routes.configurations
                    : (((((this.props.userData || {}).groups || [])[0] || {}).accessGroupConfigurationId || 0) === 11)
                      ? routes.transition
                      : IsSectionVisible(SECTIONS.PENDING_ACTION)
                        ? routes.pendingRequests
                        : ''}></WorkSpace>
                </Paper>
              </div>
            </>)
            : ''}
        </div>
        {window.location.href.indexOf('fileViewer') <= 0 &&
          <div>
            <Footer />
          </div>
        }
        <IdleSessionTimer />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    user: { isLoading, userData },
    loaderConfig: { requestCount },
    progressBar: { downloadingFiles, showDownlodProgress }
  } = state;
  return {
    isLoading,
    layout: state.layoutConfig,
    requestCount,
    userData,
    downloadingFiles: downloadingFiles,
    showDownlodProgress
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserData: (param) => dispatch(getUserData(param)),
    setNotificationData: (param) => dispatch(setNotificationData(param)),
    getNotificationData: (param) => dispatch(getNotificationMaster(param)),
    setDownloaderVisibility: param => dispatch(setDownloaderVisibility(param))
  };
};

Layout.propTypes = {
  requestCount: PropTypes.number
};
export default connect(
  mapStateToProps,
  mapDispatchToProps

)(Layout);
